import React from 'react';

export default props => {
    return (
        <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 3.30769L4.04762 7L9 1" stroke="#27AE60" stroke-width="2"/>
        </svg>
    );
};
